import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Row } from 'reactstrap';
import { without, range } from 'underscore';
import Checkbox from '../field/checkbox';

const OPTIONS = {
  residential: [
    {
      label: 'Any',
      value: ''
    },
    {
      label: 'High-Rise Condo',
      value: 'High Rise (8+)'
    },
    {
      label: 'Low-Rise Condo',
      value: 'Low Rise (1-3)'
    },
    'Manufactured',
    {
      label: 'Mid-Rise Condo',
      value: 'Mid Rise (4-7)'
    },
    // 'Quadraplex',
    {
      label: 'Single Family Home',
      value: 'Single Family'
    },
    'Townhouse',
    'Villa Attached',
    'Villa Detached'
    // {
    //   label: 'Duplex',
    //   value: 'Villa/Duplex'
    // }
    // 'BuildingDesign',
    // 'NULL'
  ],
  residential_income: [
    {
      label: 'Any',
      value: ''
    },
    'Duplex',
    'Triplex',
    'Quadplex'
  ],
  land: [
    {
      label: 'Any',
      value: ''
    },
    {
      label: 'Residential Lot',
      value: 'Residential Lot'
    },
    {
      label: 'Acreage',
      value: 'Acreage'
    },
    {
      label: 'Commercial Lot',
      value: 'Commercial Lot'
    }
  ],
  commercial: [
    {
      label: 'Any',
      value: ''
    },
    {
      label: 'Multi-Family: Low Rise (1-3 Floors)',
      value: 'Multi-Family: Low Rise (1-3 Floo'
    },
    {
      label: 'Multi-Family: Mid Rise (4-7 Floors)',
      value: 'Multi-Family: Mid Rise (4-7 Floo'
    },
    {
      label: 'Multi-Family: High Rise (8+ Floors)',
      value: 'Multi-Family: High Rise (8+ Floo'
    },
    {
      label: 'Multi-Family: Mobile/RV Community',
      value: 'Multi-Family: Mobile/RV Communit'
    },
    {
      label: 'Special Purpose: Healthcare',
      value: 'Special Purpose: Healthcare'
    },
    {
      label: 'Special Purpose: Marina/Boat Storage',
      value: 'Special Purpose: Marina/Boat Sto'
    },
    {
      label: 'Special Purpose: Misc. Other',
      value: 'Special Purpose: Misc. Other'
    },
    {
      label: 'Special Purpose: Religious Facility',
      value: 'Special Purpose: Religious Facility'
    },
    {
      label: 'Special Purpose: Theatre/Performing Art Facility',
      value: 'Special Purpose: Theatre/Perform'
    },
    {
      label: 'Senior Housing: Assisted Living Residences',
      value: 'Senior Housing: Assisted Living '
    },
    {
      label: 'Senior Housing: Congregate Senior Housing',
      value: 'Senior Housing: Congregate Senio'
    },
    {
      label: 'Retail-Commercial: Condominium',
      value: 'Retail-Commercial: Condominium'
    },
    {
      label: 'Retail-Commercial: Day Care Facility/Nursery',
      value: 'Retail-Commercial: Day Care Faci'
    },
    {
      label: 'Retail-Commercial: Post Office',
      value: 'Retail-Commercial: Post Office'
    },
    {
      label: 'Retail-Commercial: Restaurant',
      value: 'Retail-Commercial: Restaurant'
    },
    {
      label: 'Retail-Commercial: Service Station/Gas Station',
      value: 'Retail-Commercial: Service Stati'
    },
    {
      label: 'Retail-Commercial: Free Standing Building',
      value: 'Retail-Commercial: Free Standing'
    },
    {
      label: 'Retail-Commercial: Street Retail',
      value: 'Retail-Commercial: Street Retail'
    },
    {
      label: 'Retail-Commercial: Vehicle Related',
      value: 'Retail-Commercial: Vehicle Relat'
    },
    { label: 'Retail-Commercial: Other', value: 'Retail-Commercial: Other' },
    {
      label: 'Retail-Commercial: Retail Pad',
      value: 'Retail-Commercial: Retail Pad'
    },
    {
      label: 'Retail-Commercial: Shopping Center',
      value: 'Retail-Commercial: Shopping Cent'
    },
    { label: 'Office: Condominium', value: 'Office: Condominium' },
    { label: 'Office: Office Building', value: 'Office: Office Building' },
    { label: 'Office: Medical Offices', value: 'Office: Medical Offices' },
    { label: 'Office: Business Park', value: 'Office: Business Park' },
    { label: 'Office: R&D', value: 'Office: RnD' },
    { label: 'Office: Warehouse', value: 'Office: Warehouse' },
    {
      label: 'Lodging and Hospitality: Economy/Limited Service',
      value: 'Lodging and Hospitality: Economy'
    },
    {
      label: 'Lodging and Hospitality: Full Service',
      value: 'Lodging and Hospitality: Full Se'
    },
    { label: 'Industrial: Condominium', value: 'Industrial: Condominium' },
    { label: 'Industrial: Flex Space', value: 'Industrial: Flex Space' },
    { label: 'Industrial: Business Park', value: 'Industrial: Business Park' },
    { label: 'Industrial: Manufacturing', value: 'Industrial: Manufacturing' },
    {
      label: 'Industrial: Office Showroom',
      value: 'Industrial: Office Showroom'
    },
    { label: 'Industrial: R&D', value: 'Industrial: RnD' },
    {
      label: 'Industrial: Self/Mini-Storage Facility',
      value: 'Industrial: Self/Mini-Storage Fa'
    },
    {
      label: 'Industrial: Truck Terminal/Hub/Transit Facility',
      value: 'Industrial: Truck Terminal/Hub/T'
    },
    { label: 'Industrial: Warehouse', value: 'Industrial: Warehouse' },
    {
      label: 'Industrial: Distribution Warehouse',
      value: 'Industrial: Distribution Warehou'
    },
    {
      label: 'Industrial: Refrigerated/Cold Storage',
      value: 'Industrial: Refrigerated'
    }
  ]
};

function RenderCheckbox(props) {
  const { input, meta, ...checkboxProps } = props;
  const checked =
    (input.value && input.value.length === 0 && props.value === '') ||
    (input.value.indexOf && input.value.indexOf(props.value) !== -1);
  return (
    <Checkbox
      {...checkboxProps}
      checked={checked}
      onChange={e => {
        const { checked } = e.target;

        var newValue = [].concat(input.value);

        if (checked && props.value === '') {
          newValue = [];
        } else if (checked && newValue.indexOf(props.value) === -1) {
          newValue.push(props.value);
        } else {
          newValue = without(newValue, props.value);
        }

        if (newValue.indexOf('') !== -1) {
          newValue = without(newValue, '');
        }

        return input.onChange(newValue);
      }}
    />
  );
}

class BuildingTypeFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const labelClassName = `${BS.justifyContentStart} ${BS.mb1}`;
    const {
      className,
      numCols,
      numColsSm,
      numInnerCols,
      numInnerColsSm,
      type,
      ...props
    } = this.props;
    const options = OPTIONS[type];
    const colSize = Math.ceil(12 / numCols);
    const colSizeSm = Math.ceil(12 / numColsSm);
    const colInnerSize = Math.ceil(12 / numInnerCols);
    const colInnerSizeSm = Math.ceil(12 / numInnerColsSm);
    const numPerCol = Math.ceil(options.length / numCols);
    const numPerInnerCol = Math.ceil(numPerCol / numInnerCols);

    var i = 0;

    return (
      <Row className={className}>
        {range(numCols).map(col => {
          return (
            <Col key={col} sm={colSizeSm} md={colSize}>
              <FormGroup>
                <Row>
                  {range(numInnerCols).map(innerCol => {
                    return (
                      <Col key={innerCol} sm={colInnerSizeSm} md={colInnerSize}>
                        {range(numPerInnerCol).map(() => {
                          const data = options[i];
                          i++;
                          return data ? (
                            <RenderCheckbox
                              {...props}
                              key={i}
                              className={labelClassName}
                              value={data.value !== undefined ? data.value : data}
                              label={data.label || data}
                            />
                          ) : null;
                        })}
                      </Col>
                    );
                  })}
                </Row>
              </FormGroup>
            </Col>
          );
        })}
      </Row>
    );
  }
}

BuildingTypeFilter.defaultProps = {
  numCols: 3,
  numInnerCols: 2,
  numColsSm: 2,
  numInnerColsSm: 1,
  type: 'residential'
};
export { OPTIONS };
export default BuildingTypeFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/building-type-filter.js